import { createContext } from 'react';

export default createContext<Date | undefined>(undefined);
